/**
 * Standard Mixpanel email fields for events and People profiles.
 * `$email` is Mixpanel's reserved property for the Users UI email column.
 */

export function mixpanelEmailEventProperties(
  email: string | undefined | null,
): Record<string, string> {
  const e = String(email ?? "").trim();
  if (!e) return {};
  return { $email: e, email: e, user_email: e };
}

export function mixpanelEmailPeopleProperties(
  email: string | undefined | null,
  extra: Record<string, string> = {},
): Record<string, string> {
  const e = String(email ?? "").trim();
  return { ...(e ? { $email: e, email: e } : {}), ...extra };
}
